/**
 * Device and viewport detection utility
 * Distinguishes between PC / laptop (desktops & laptops)
 * and mobile / tablet ("taps") devices.
 */

export const isMobileOrTabletDevice = () => {
  if (typeof window === 'undefined') return false;

  // Viewport width matching Tailwind 'lg' breakpoint (1024px)
  // and Chrome DevTools 'Laptop - 1024px' preset:
  // - Laptop & PC screens: >= 1024px
  // - Mobile & Tablets ("taps"): < 1024px
  const width =
    window.innerWidth ||
    (document.documentElement ? document.documentElement.clientWidth : 0);

  return width < 1024;
};

export default isMobileOrTabletDevice;

